(function () {
    if (typeof window.ProjectStore === 'undefined') return;

    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get('project_id');
    const isResume = urlParams.get('resume');

    const formContainer = document.querySelector('[data-product-id]');
    if (!formContainer) return;

    const productId = formContainer.getAttribute('data-product-id');
    const productHandle = formContainer.getAttribute('data-product-handle');
    const productTitle = formContainer.getAttribute('data-product-title');
    const stepTotal = parseInt(formContainer.getAttribute('data-step-total') || '4', 10);

    const navEntries = performance.getEntriesByType('navigation');
    const navType = navEntries.length > 0 ? navEntries[0].type : '';

    if (navType === 'navigate' && !isResume) {
        localStorage.removeItem('pf_current_step');
        localStorage.removeItem('pf_last_medium');
        localStorage.removeItem('pf_last_size');
        localStorage.removeItem('pf_last_finish');
        localStorage.removeItem('pf_last_background');
        localStorage.removeItem('pf_last_people');
        localStorage.removeItem('pf_last_message');
        localStorage.removeItem('pf_last_instructions');
        localStorage.removeItem('pf_uploaded_links');
        localStorage.removeItem('pf_active_project_id');
        window.pfActiveProjectId = null;
    }

    // 1. Check for Resume flow
    if (projectId && (isResume === '1' || isResume === 'true')) {
        const project = window.ProjectStore.getById(projectId);

        if (project && project.status === 'in_progress') {
            // Verify project matches current product
            if (project.product_handle === productHandle || project.product_id == productId) {

                // Hydrate LocalStorage so the existing form logic picks it up on restore
                if (project.form_data) {
                    if (project.form_data.finish) localStorage.setItem('pf_last_finish', project.form_data.finish);
                    if (project.form_data.background) localStorage.setItem('pf_last_background', project.form_data.background);
                    if (project.form_data.medium) localStorage.setItem('pf_last_medium', project.form_data.medium);
                    if (project.form_data.people) localStorage.setItem('pf_last_people', project.form_data.people);
                    if (project.form_data.message) localStorage.setItem('pf_last_message', project.form_data.message);
                    if (project.form_data.instructions) localStorage.setItem('pf_last_instructions', project.form_data.instructions);
                }

                if (project.assets && project.assets.length > 0) {
                    const links = project.assets.map(a => a.url);
                    localStorage.setItem('pf_uploaded_links', JSON.stringify(links));
                }

                // Determine step to resume
                let resumeStep = project.step_completed + 1;
                if (resumeStep > stepTotal) resumeStep = stepTotal;

                // Expose resume step & ID for form script so it doesn't create a new project on first step change
                window.pfResumeStep = resumeStep;
                window.pfActiveProjectId = projectId;
                window.ProjectStore.setLastActive(projectId); // Ensures if user clicks anything we know who is active

                showToast("Welcome back — your progress was saved.");

                // Scroll to form slightly after load
                setTimeout(() => {
                    formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 500);

            } else {
                showToast("We couldn’t find that project for this product. Start a new portrait below.");
                window.pfActiveProjectId = null;
            }
        } else {
            showToast("We couldn’t find that active project. Start a new portrait below.");
            window.pfActiveProjectId = null;
        }
    } else {
        // No explicit resume ID in URL. 
        // 2. Check Multiple Projects for this product
        const incomplete = window.ProjectStore.getIncomplete();
        const productProjects = incomplete.filter(p => p.product_handle === productHandle || p.product_id == productId);

        if (productProjects.length > 0 && !localStorage.getItem('pf_active_project_id')) {
            injectInlineResumePanel(productProjects, formContainer);
        }

        window.pfActiveProjectId = localStorage.getItem('pf_active_project_id') || null;
    }

    // Toast helper
    function showToast(message) {
        const toast = document.createElement('div');
        toast.className = 'pf-resume-toast';
        toast.textContent = message;
        document.body.appendChild(toast);

        // CSS via JS for quick injection
        Object.assign(toast.style, {
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%) translateY(100px)',
            background: '#2d2f35',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '99px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: '9999',
            transition: 'transform 0.4s cubic-bezier(0.2, 0, 0, 1)',
            fontSize: '1.4rem',
            fontWeight: '500',
            textAlign: 'center',
            width: 'max-content',
            maxWidth: '90vw'
        });

        requestAnimationFrame(() => {
            toast.style.transform = 'translateX(-50%) translateY(0)';
        });

        setTimeout(() => {
            toast.style.transform = 'translateX(-50%) translateY(100px)';
            setTimeout(() => toast.remove(), 400);
        }, 4000);
    }

    // Inline panel helper
    function injectInlineResumePanel(projects, container) {
        const mostRecent = projects[0];
        const panel = document.createElement('div');
        panel.className = 'pf-inline-resume-panel';

        const countText = projects.length === 1 ? `1 ${productTitle} in progress` : `${projects.length} ${productTitle}s in progress`;

        panel.innerHTML = `
            <div class="pf-irp-icon">⏳</div>
            <div class="pf-irp-content">
                <strong>You have ${countText}</strong>
                <div class="pf-irp-actions">
                    <a href="/products/${productHandle}?resume=1&project_id=${mostRecent.project_id}" class="pf-irp-btn-primary">Continue Most Recent</a>
                    <a href="/pages/my-masterpieces" class="pf-irp-btn-secondary">View All</a>
                </div>
            </div>
        `;

        Object.assign(panel.style, {
            background: '#f4ebff',
            border: '1px solid #eadbff',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            color: '#2d2f35'
        });

        const icon = panel.querySelector('.pf-irp-icon');
        Object.assign(icon.style, {
            fontSize: '24px',
            lineHeight: '1'
        });

        const actions = panel.querySelector('.pf-irp-actions');
        Object.assign(actions.style, {
            display: 'flex',
            gap: '10px',
            marginTop: '10px',
            flexWrap: 'wrap'
        });

        const btnStyles = {
            padding: '8px 16px',
            borderRadius: '99px',
            fontSize: '1.3rem',
            fontWeight: '600',
            textDecoration: 'none',
            display: 'inline-block'
        };

        const primaryBtn = panel.querySelector('.pf-irp-btn-primary');
        Object.assign(primaryBtn.style, btnStyles);
        Object.assign(primaryBtn.style, {
            background: '#6a0dad',
            color: '#fff'
        });

        const secondaryBtn = panel.querySelector('.pf-irp-btn-secondary');
        Object.assign(secondaryBtn.style, btnStyles);
        Object.assign(secondaryBtn.style, {
            background: '#fff',
            color: '#6a0dad',
            border: '1px solid #6a0dad'
        });

        // Insert at the very top of the form card
        const formCard = container.closest('.custom-form-card') || container;
        formCard.prepend(panel);
    }
})();
